<template>
<div class="body">
  <el-row :gutter="20" class="body-top">
    <el-col :span="4" v-for="(item, index) in topNavList" :key="index"><router-link :to="item.path"><div class="grid-content" :class="colorList[index]">{{item.label}}</div></router-link></el-col>
    <!-- <el-col :span="4"><router-link to="/fileFolderPerson"><div class="grid-content bg-Success">个人文件柜</div></router-link></el-col>
    <el-col :span="4"><router-link to="/kaoqinPerson/kaoqintj"><div class="grid-content bg-Warning">个人考勤</div></router-link></el-col>
    <el-col :span="4"><router-link to="/workPlanManagement"><div class="grid-content bg-Turquoise">工作计划</div></router-link></el-col>
    <el-col :span="4"><router-link to="/gongZuorz"><div class="grid-content bg-Orange">工作日志</div></router-link></el-col>
    <el-col :span="4"><router-link to="/mailBox"><div class="grid-content bg-SpringGreen">我的邮件</div></router-link></el-col> -->
  </el-row>
  <el-row class="body-content">
    <el-row class="content1" :gutter="20">
      <el-col :span="8">
        <div class="card-box" v-loading="newLoading">
          <div class="card-title clearfix"><span class="f-left">最近新闻</span><span class="f-right blue"><router-link to="newsManagement">更多</router-link></span></div>
          <div class="card-content">
            <div class="clearfix card-item" v-for="(item, index) in newsList" :key="index" @click="newDetailClick(item.id)">
              <div class="f-left">{{item.title}}</div>
              <div class="f-right">{{item.time}}</div>
            </div>
            <div class="text-center mt20" v-if="newsList.length==0">暂无新闻...</div>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="card-box" v-loading="dbLoading">
          <div class="card-title clearfix"><span class="f-left">待办事宜</span><span class="f-right blue"><router-link to="/todo">更多</router-link></span></div>
          <div class="card-content" style="padding:0;">
            <div class="table clearfix">
              <div class="f-left title-1">待办事件</div>
              <div class="f-left title-2">待办详情</div>
              <div class="f-left title-3">状态</div>
            </div>
            <div class="clearfix card-item" v-for="(item, index) in todoList" :key="index" @click="todoDetailClick(item)">
              <div class="f-left title-1">{{item.name}}</div>
              <div class="f-left title-2"><span>发起人：{{item.startUserName}}</span>，时间：{{item.createTime}}<span></span><span></span></div>
              <div class="f-left title-3">{{item.state}}</div>
            </div>
            <div class="text-center mt20" v-if="todoList.length==0">暂无待办事宜...</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="content2" style="margin-top:10px !important;" :gutter="20">
      <el-col :span="8">
        <div class="card-box" v-loading="noticeLoading">
          <div class="card-title clearfix"><span class="f-left">通知公告</span><span class="f-right blue"><router-link to="noticeManagement">更多</router-link></span></div>
          <div class="card-content">
            <div class="clearfix card-item" v-for="(item, index) in noticeList" :key="index" @click="noticeDetailClick(item.id)">
              <div class="f-left">{{item.title}}</div>
              <div class="f-right">{{item.time}}</div>
            </div>
            <div class="text-center mt20" v-if="noticeList.length==0">暂无公告...</div>
          </div>
        </div>
      </el-col>    
      <el-col :span="16">
        <div class="card-box">
          <div class="card-title clearfix"><span class="f-left">消息管理</span><span class="f-right blue"><router-link to="messageManagement">更多</router-link></span></div>
          <div class="card-content">
            <div class="card-box msgBox" style="padding:5px;min-width:720px;">
              <MessageManagement ref="MeetingManagementDiv"/>       
            </div>
          </div>
        </div>
        <!-- <div class="card-box" style="padding:5px;min-width:720px;">
          <vue-event-calendar :events="scheduleList" @monthChanged="monthChange" @dayChanged="dayChange"></vue-event-calendar>         
        </div> -->
      </el-col>    
    </el-row>
    <el-row class="content3" style="margin-top:10px !important;" :gutter="20">
       <el-col :span="24">
        <div class="card-box">
          <div class="card-title clearfix"><span class="f-left">公共文件柜</span><span class="f-right blue"><router-link to="fileFolder">更多</router-link></span></div>
          <div class="card-content">
            <div class="card-box fileBox" style="padding:5px;min-width:720px;">
              <FileFolder ref="FileFolderDiv"/>       
            </div>
          </div>
        </div>
      </el-col>  
    </el-row>
  </el-row>
</div>
</template>
<script type="text/javascript">
import {newsListURL, noticeListURL, schedulePeriodAllURL, runtimeTaskListURL} from '@/api/http'
import MessageManagement from './messageManagement/index.vue'
import FileFolder from './fileFolder/index.vue'
export default {
  components: {
    MessageManagement,
    FileFolder
  },
  name: 'home',
  data () {
    return {
      newLoading: true,
      noticeLoading: true,
      dbLoading: true,
      newsList: [],   
      todoList: [],
      noticeList: [],
      scheduleList: [],
      topNavList: [],
      colorList: ['bg-Blue', 'bg-Success', 'bg-Warning', 'bg-Turquoise', 'bg-Orange', 'bg-SpringGreen'],
      paginationData: {
        page: 1,
        size: 10,
        total: 0,
      }
    }
  },
  created () {
    this.getNewsList()
    this.getNoticeList()
    this.getScheduleList()
    this.getTodoList()
    this.getTopNav()
  },
  watch: {  
　　search: {  
　　　　handler(newValue, oldValue) {  
　　　　 　for(var key in newValue){
          this.paginationData[key] = newValue[key]
        }
        this.paginationData.page = 1
        // this.handlePageSizeChange(newsListURL, newsList)　  
　　　　},  
　　　　deep: true  
　　}  
  }, 
  methods: {
    // 获取头部快捷导航
    getTopNav () {
      const menus = JSON.parse(sessionStorage.getItem('menus'))
      menus.map(item => {
        if(item.label == '个人事务') {
          item.submenu.map(child => {
            if (child.label == '日程安排' || child.label == '我的邮箱' || child.label == '个人文件柜' || child.label == '个人考勤' || child.label == '工作日志') {
              this.topNavList.push(child)
            } 
          })       
        } else if (item.label == '行政办公') {
          item.submenu.map(child => {
            if (child.label == '工作计划管理') {
              this.topNavList.push(child)
            } 
          }) 
        } 
      })
    },
    getNewsList () {
      this.newLoading = true
      this.$http.post(newsListURL, this.paginationData)
        .then(res => {
          this.newLoading = false
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            this.newsList = res.data
          }
        })
        .catch(err => {
          this.newLoading = false
          console.log(err)
        })　  
    },
    getNoticeList () {
      this.noticeLoading = true
      this.$http.post(noticeListURL, this.paginationData)
        .then(res => {
          this.noticeLoading = false
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            this.noticeList = res.data
          }
        })
        .catch(err => {
          this.noticeLoading = false
          console.log(err)
        })　  
    },
    getScheduleList () {
      let myDate = new Date()
      let OY = myDate.getFullYear()
      let OM = myDate.getMonth()+1
      let OD = myDate.getDate()
      let startTime = OY+ '-' + OM + '-' + '1'
      let endTime = OY+ '-' + (OM+1) + '-' + '31'
      this.$http.post(schedulePeriodAllURL,{startTime: startTime, endTime: endTime})
        .then(res => {
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            if (res) {
              res.map(item => {
                this.scheduleList.push({date: item.startTime, title: item.title, desc: item.description})
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })　  
    },
    getTodoList () {
      this.dbLoading = true
      this.$http.post(runtimeTaskListURL, this.paginationData)
        .then(res => {
          this.dbLoading = false
          if (res.msg) {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          } else {
            this.todoList = res.data
          }
        })
        .catch(err => {
          this.dbLoading = false
          console.log(err)
        })　  　  
    },
    monthChange (month) {

    },
    dayChange (day) {

    },
    newDetailClick (id) {
      this.$router.push({
        path: '/newsDetails/', 
        name: '新闻详情',
        params: { 
          id: id,
        },
        query: { 
          id: id,
        }
      })
    },
    noticeDetailClick (id) {
      this.$router.push({
        path: '/noticesDetails/', 
        name: '公告详情',
        params: { 
          id: id
        },
        query: { 
          id: id
        }
      })
    },
    todoDetailClick (row) {
      if (row.isFirstStep) {
          this.$router.push({
            path: '/apply', 
            name: '',
            params: { 
              id: row.taskId,
            },
            query: { 
              id: row.taskId
            }
          })
          return
        }
        this.$router.push({
          path: '/todoDetail', 
          name: '',
          params: { 
            id: row.taskId,
          },
          query: { 
            id: row.taskId
          }
        })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.fileBox{
  border: none !important;

 .file-top.clearfix{
    display: none !important;
  }
}
/deep/.msgBox{
    border: none !important;
  .rowTop{
    display: none !important;
  }
}
</style>
<style type="text/css" lang="less">
  .body{
    .body-top{
      background:#fff;
      padding:10px;
    }
    .body-content{
      padding:10px;
      background:#fff;
      .card-box{
        width:100%;
        height:320px;
        overflow: auto;
        border:1px solid #ccc;
        border-radius: 3px;
        .card-item{
          padding:5px 0;
          cursor: pointer;
          &:hover{
            color:#409EFF;
          }
          .f-left{
            width: 70%;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
           
          }
          .f-right{
            width:30%;
            text-align: right;
            color:#999;
            overflow: hidden;
            height:20px;
          }
        }
        .card-title{
          background:#f6f6f6;
          padding:10px;
          color:#696969;
          font-size: 14px;
          font-weight: bold;
          border-bottom:1px solid #ccc;
        }
        .card-content{
          padding:10px;
          .table{
            color:#696969;
            padding: 6px 10px;
            border-bottom:2px solid #409EFF; 
          }
          .title-1{
            width:25%;
            padding-left:10px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .title-2{
            width:60%;
            overflow: hidden;
            text-align: center;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .title-3{
            width:15%;
            text-align: center;
          }
        }
      }
    }
    .grid-content {
      border-radius: 4px;
      padding:10px;
      text-align: center;
      color:#fff;
      font-size:16px;
    }
    .bg-Blue{
      background-color:#409EFF
    }
    .bg-Success{
      background-color:#67C23A;
    }
    .bg-Warning{
      background-color:#E6A23C;
    }
    .bg-Turquoise{
      background-color:#40E0D0;
    }
    .bg-Orange{
      background-color:#FFA500;
    }
    .bg-SpringGreen{
      background-color:#3CB371;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/home.vue